module.exports = __webpack_public_path__ + "static/img/product-incelemede-warning.7a267099.svg";